import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The members an invoice can be handed to for approval — active, allowed to read incoming
 * invoices, and not asked about it yet. Read on the invoice's own rule, so every approver sees
 * the list, not only those who may read the organisation's members.
 *
 * @param incomingInvoiceId - The invoice to hand over.
 */
export function useIncomingInvoiceHandoverCandidates(incomingInvoiceId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", incomingInvoiceId, "handover-candidates"],
		queryFn: async () => {
			const response = await client.incoming_invoices[":incomingInvoiceId"][
				"handover-candidates"
			].$get({ param: { incomingInvoiceId } });
			const data = await responseHandler(response);
			return data.candidates;
		},
	});

	/** Return */
	return { ...query, candidates: query.data ?? [] };
}
